<template>
  <div
    v-if="itemDetail"
    class="project_info_data d_flex flex_direction_col fz12 c_1A1A1A"
  >
    <div v-if="cmsProblemNode" class="flex_1">
      <div v-if="cmsProblemNode.children.length" class="problem_head d_flex justify_content_sb">
        <span class="problem_node_title font_w_bold">{{ cmsProblemNode.name }}</span>
        <router-link :to="`${cmsProblemNode.nodeModel.route}/${cmsProblemNode.children[0].id}?pcode=problem`">更多 >></router-link>
      </div>
      <div class="problem_list">
        <ul>
          <li v-for="item in cmsProblemNode.children.slice(0,3)" :key="item.id"> <router-link :to="`${item.nodeModel.route}/${item.id}?pcode=problem`">{{ item.name }}</router-link> </li>
        </ul>
      </div>
    </div>

    <div class="new_bid_w d_flex flex_direction_col">
      <div class="font_w_bold record_title">最新出价</div>
      <div class="record_list flex_1">
        <ul>
          <li v-for="(item,index) in itemDetail.biddings.slice(0,3)" :key="item.id">
            <p class="d_flex">
              <span v-if="index===0" class="flex_1">{{ itemDetail.state === 9?'成交':'领先' }}</span>

              <span v-else class="flex_1">出局</span>

              <span class="flex_1">{{ item.phone }}</span>
              <span class="flex_1 text_right">￥{{ numTranFloat(item.bidPrice) }}</span>
            </p>
            <p class="c_808080">{{ item.createdAt }}</p>
          </li>
        </ul>

        <div v-if="itemDetail.biddings && !itemDetail.biddings.length" style="height:100%" class="x_y_center">
          <img src="@/assets/images/empty_icon.png" alt="">
          <span style="margin:0 0 0 10px">暂无数据</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { regMobile, numTranFloat } from '@/utils'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    itemDetail: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['siteInfo', 'cmsProblemNode']),

    // 隐藏手机号
    regMobile() {
      return function(phone) {
        return regMobile(phone)
      }
    },

    // 格式化金额（小数点）
    formatMoney: function() {
      return function(num) {
        return Number(num).toLocaleString()
      }
    },
    numTranFloat:function(){
      return function(num){
        return numTranFloat(num)
      }
    }
  },
  created() {
  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
.project_info_data {
    width: 318px;
    border: 1px solid #e6e6e6;
    .new_bid_w{
      flex: 1.2;
    }
    .problem_head {
      padding: 18px 10px 0 20px;
      border-bottom: 1px solid #e6e6e6;
    }
    .problem_list {
      margin: 6px 0 0 0;
      padding: 0 20px;
      & li {
        padding: 10px 0;
        border-bottom: 1px solid #e6e6e6;
        &:last-child {
          border: 0;
        }
      }
    }
    .record_title {
      padding: 9px 19px 8px 19px;
      background-color: #e5eef6;
    }
    .record_list {
      padding: 0 20px;
      & li {
        padding: 10px 0 6px 0;
        border-bottom: 1px solid #e6e6e6;
        &:last-child{
          border: 0;
        }
        p {
          &:first-child {
            margin: 0 0 5px 0;
          }
        }
      }
    }

    .problem_node_title {
      padding: 0 0 6px 0;
      border-bottom: 2px solid #0983cc;
    }
  }
</style>
